import Text from '@deprecated-ui/common/Text';
import { BondCouponHistoryByYear } from 'global/Securities/types/api/bond';
import HistoryRowItem from './HistoryRowItem';
import { HistoryGroupContainer } from '../../../styled';

interface Props {
  history: BondCouponHistoryByYear;
}

export default function HistroyRowGroup({ history }: Props) {
  return (
    <HistoryGroupContainer>
      <Text color="#858585">Kupon {history.year}</Text>
      {history.items.map((item) => (
        <HistoryRowItem
          date={item.date}
          amount={item.amount}
          accruedInterest={item.coupon?.user}
          sellerCoupon={item.coupon?.seller}
        />
      ))}
    </HistoryGroupContainer>
  );
}
